// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { IconWrapper } from "@insite/mobius/Icon";
import ToastPropsDefault, { toasterProps as toasterPropsDefault } from "@insite/mobius/Toast/presentationProps";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import IconAlert from "@pace/XDL/Icons/IconAlert";
import IconError from "@pace/XDL/Icons/IconError";
import IconInfo from "@pace/XDL/Icons/IconInfo";
import IconSuccess from "@pace/XDL/Icons/IconSuccess";
import IconX from "@pace/XDL/Icons/IconX";
import { buttonTransparent } from "@pace/XDL/PreStyle/button";
import { xBaseTheme } from "@pace/XDL/types";
import { color } from "@pace/XDL/Utilities";
import { css, ThemeProps } from "styled-components";

export default {
    defaultProps: {
        ...ToastPropsDefault,
        mergeCss: true,
        closeButtonProps: {
            mergeCss: true,
            color: "transparent",
            buttonType: "solid",
            shape: "pill",
            css: css`
                position: absolute;
                top: 0;
                right: 0;
                border: 0;
                width: 24px;
                height: 24px;
                padding: 0;
                ${buttonTransparent}
                &:hover ${IconWrapper} {
                    color: ${color("secondary, 0.5")};
                }
            `,
            size: 24,
        },
        closeButtonIconProps: {
            mergeCss: true,
            src: IconX,
            size: 9,
            color: "secondary",
        },
        iconProps: {
            mergeCss: true,
            size: 18,
            css: css`
                margin-top: 2px;
                margin-right: 10px;
            `,
        },
        iconSrcByMessage: {
            success: IconSuccess,
            warning: IconAlert,
            danger: IconError,
            info: IconInfo,
        },
        bodyTypographyProps: {
            mergeCss: true,
            css: css`
                word-wrap: break-word;
                white-space: pre-wrap;
                width: calc(100% - 28px);
                & > ${TypographyStyle}, & > div > ${TypographyStyle} {
                    ${({ theme }: ThemeProps<BaseTheme>) =>
                        breakpointMediaQueries(
                            theme,
                            [
                                css`
                                    font-size: 12px;
                                    line-height: 16px;
                                `,
                                null,
                                css`
                                    font-size: 14px;
                                    line-height: 22px;
                                `,
                                null,
                                null,
                            ],
                            "min",
                        )}

                    &:last-child {
                        margin-bottom: 0;
                    }
                }
            `,
            color: "text.main",
        },
        cssOverrides: {
            toast: css`
                border-style: solid;
                border-width: 1px;
                background: ${({ messageType }: any) => color(`${messageType}.light`)};
            `,
            toastBody: css`
                &&& {
                    margin: 0;
                    width: 100%;
                }
                align-items: flex-start;
                padding: 13px;
                margin-top: 2px;
            `,
        },
    },
    toasterProps: {
        ...toasterPropsDefault,
    },
} as xBaseTheme["toast"];
